import { injectable, inject } from 'inversify';
import { CommandHandler } from '@/app/tracking/api';
import { AnswerQuestionTrackingCommand, AnswerQuestionTrackingCommandPayload } from '../api';
import { Scorm2004QuestionDataStore } from './scorm2004-question-data-store';

// temporary disabled interaction sending to workaround Moodle BUG MDL-68896
const ENABLE_SCORM_INTERACTIONS = false

@injectable()
export class Scorm2004AnswerQuestionCommandHandler implements CommandHandler<AnswerQuestionTrackingCommand> {

  constructor(
    @inject(Scorm2004QuestionDataStore)
    private store: Scorm2004QuestionDataStore) {
  }

  public async execute(command: AnswerQuestionTrackingCommandPayload) {

    // temporary disabled interaction sending
    if (ENABLE_SCORM_INTERACTIONS) {
      await this.store.insert({
        ...command.question,
        type: command.meta.type,
        description: command.meta.title
      });
    }
  }
}
